import { TemplateNavFooterBasicStyles } from "./NavFooter-Level0.styles"

const t = document.createElement('template')
t.innerHTML = `
  <section class="ascend-footer" aria-label="Footer">
    <nav class="ascend-footer__container" aria-label="Site Footer">
      <div class="ascend-footer__container__border__top"></div>
      <slot name="footer-links"></slot>
      <div class="ascend-footer__copyright"><slot name="copyright"></slot></div>
    </nav>
  </section>
`
const TemplateNavFooterBasic = t

class NavFooterBasic extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavFooterBasicStyles.content.cloneNode(true))
    shadow.appendChild(TemplateNavFooterBasic.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavFooterBasic connectedCallback')
  }
}

// legacy
// customElements.define('ts-navfooter-basic', NavFooterBasic)
// new
if (!customElements.get('ts-navfooter-level0')) {
  customElements.define('ts-navfooter-level0', NavFooterBasic)
}
export { NavFooterBasic }
